import { useSelector } from 'react-redux';
import { selectActiveLanguage, selectDefaultLanguageId, selectTranslations } from '../redux/modules/data/localizationSlice';

const useTranslation = (useDefaultLanguage = false) => {
	const allTranslations = useSelector((state) => selectTranslations(state));
	const activeLanguageId = useSelector((state) => selectActiveLanguage(state));
	const defaultLanguageId = useSelector((state) => selectDefaultLanguageId(state));

	const t = (translationKey) => translate(translationKey, allTranslations, useDefaultLanguage ? defaultLanguageId : activeLanguageId, defaultLanguageId);

	return t;
};

export default useTranslation;

export const translate = (translationKey, allTranslations, activeLanguageId, defaultLanguageId) => {
	const translationsForTranslationKey = allTranslations?.[translationKey];

	const activeTranslation = translationsForTranslationKey?.[activeLanguageId];
	if (activeTranslation && activeTranslation !== '') {
		return activeTranslation;
	}
	const defaultTranslation = translationsForTranslationKey?.[defaultLanguageId];
	if (defaultTranslation && defaultTranslation !== '') {
		return defaultTranslation;
	}

	return translationKey;
};
